@if (linkElement === "a") {
  <a
    class="m-link {{ styleClass || '' }} {{ disabled ? 'disabled' : '' }}"
    [href]="link"
    [target]="target"
    >{{ label }}</a
  >
} @else {
  <span
    class="m-link {{ styleClass || '' }} {{ disabled ? 'disabled' : '' }}"
    (click)="publishLinkClick()"
    >{{ label }}</span
  >
}
